import React from "react";
const PrevArrow = ({
  className,
  id,
  onClick,
  fill,
  hoverColor,
  settings,
  height,
  width
}) =>
  <button
    className={className}
    id={id}
    tabIndex="0"
    style={{
      ...settings.arrowStyles,
      top: settings.top,
      left: settings.left,
      bottom: settings.bottom,
      cursor: "pointer",
      border: "none",
      background: "transparent"
    }}
    onClick={onClick}
    onMouseOver={e =>
      (e.currentTarget.firstChild.firstChild.firstChild.style.fill = hoverColor)}
    onMouseOut={e =>
      (e.currentTarget.firstChild.firstChild.firstChild.style.fill = fill)}
  >
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 57"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-221.000000, -192.000000)"
          fill={fill}
        >
          <g
            id="gallery-arrow-copy"
            transform="translate(221.000000, 192.000000)"
          >
            <path
              d="M29.8343189,3.61917078 L6.79738562,28.1505422 L29.8343189,52.6819136 L26.4356261,56.3010844 L0,28.1505422 L26.4356261,7.28306304e-14 L29.8343189,3.61917078 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  </button>;

PrevArrow.defaultProps = {
  className: "prevArrow",
  fill: "#fff",
  width: "20px",
  height: "37px",
  top: "355px",
  style: {
    position: "absolute",
    zIndex: "4444",
    left: "10px",
    top: "120px"
  },
  onClick: null
};
export default PrevArrow;
